<h1 mat-dialog-title>Dodawanie grupy</h1>
<div mat-dialog-content>
  <form [formGroup]="groupForm">
    <app-simple-string-value-accessor label="Nazwa grupy"
                                      formControlName="name"></app-simple-string-value-accessor>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button
          action-button
          color="primary"
          class="width-100"
          type="button"
          [action]="create.bind(this)"
          [disabled]="groupForm.invalid">
    Zatwierdź dodanie
  </button>
</div>
